// src/components/CoachNotesPanel.js
import React from "react";

export default function CoachNotesPanel({ notes, setNotes, readOnly = false }) {
  return (
    <div className="card" style={{ padding: 12, borderRadius: 12, border: "1px solid var(--border)", marginTop: 12 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <strong>Coach Notes</strong>
        <small style={{ color: "var(--muted)" }}>Private — not sent to client</small>
      </div>

      <div style={{ display: "grid", gap: 10, marginTop: 8 }}>
        <div>
          <label>Observations</label>
          <textarea
            rows={3}
            value={notes.observations}
            onChange={(e) => setNotes(n => ({ ...n, observations: e.target.value }))}
            disabled={readOnly}
          />
        </div>
        <div>
          <label>Reframes</label>
          <textarea
            rows={3}
            value={notes.reframes}
            onChange={(e) => setNotes(n => ({ ...n, reframes: e.target.value }))}
            disabled={readOnly}
          />
        </div>
        <div>
          <label>Next Steps</label>
          <textarea
            rows={3}
            value={notes.next}
            onChange={(e) => setNotes(n => ({ ...n, next: e.target.value }))}
            disabled={readOnly}
          />
        </div>
      </div>
    </div>
  );
}
